import React, { createContext, useContext } from "react"

import type { useSortable } from "@dnd-kit/sortable"

type SortableHandle = ReturnType<typeof useSortable>

/**
 * Lets a widget's title bar act as the sortable activator without threading
 * dnd-kit props through every widget component. Consumers outside a sortable
 * grid — the widget configuration preview, for one — get an empty value and
 * render a plain, undraggable title bar.
 */
interface WidgetDragHandleValue {
  attributes?: SortableHandle["attributes"]
  listeners?: SortableHandle["listeners"]
  setActivatorNodeRef?: SortableHandle["setActivatorNodeRef"]
}

const WidgetDragHandleContext = createContext<WidgetDragHandleValue>({})

export const WidgetDragHandleProvider: React.FC<{
  value: WidgetDragHandleValue
  children: React.ReactNode
}> = ({ value, children }) => (
  <WidgetDragHandleContext.Provider value={value}>
    {children}
  </WidgetDragHandleContext.Provider>
)

export function useWidgetDragHandle(): WidgetDragHandleValue {
  return useContext(WidgetDragHandleContext)
}
